import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadToken } from "../../store/userSlice/userSlice";
import { loginVerify } from "../../store/userSlice/userRequests";

const LoadApp = ({ children }) => {
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    dispatch(loadToken());
    dispatch(loginVerify())
      .then(() => {
        setLoaded(true);
      })
  }, []);

  return loaded ? children : null;
}

export default LoadApp;